export default __webpack_public_path__ + "static/media/pop-check.8de233ec.svg";